export { default as FAQInfoText } from "./faqInfoText";
